import AppFeatureEditor from './AppFeatureEditor'
import * as React from 'react'
import {IFeatureLayerInfo} from '../../core/interfaces/models'
import {IEditsDispatcher, IGeometryEditsDispatcher, IPopupDispatcher} from '../../core/interfaces/dispatchers'
import {Feature} from '../../core/models'
import appConfig from '../../reducers/appConfig'
import ParcelFeatureEditor from './Reg/ParcelFeatureEditor'
import QuarterFeatureEditor from './Reg/QuarterFeatureEditor'
import {OnBeforeDelete} from './Reg/OnBeforeDelete'
import SiteLineFeatureEditor from './Reg/SiteLineFeatureEditor'
import RegPlanEditor from './Reg/RegPlanEditor'
import StreetAreaEditor from './StreetReg/StreetAreaEditor'
import {ArchPlanHistoryEditor} from './ArchPlan/ArchPlanHistoryEditor'
import {IAppUser} from '../../interfaces/reducers'

interface Props {
  feature: Feature
  layerInfo: IFeatureLayerInfo
  style?: React.CSSProperties
  editsDispatcher?: IEditsDispatcher
  geometryEditsDispatcher?: IGeometryEditsDispatcher
  popupDispatcher: IPopupDispatcher
  onFeatureChanged?: (feature: Feature) => void
  buttonsClassname?: string
  onAfterSave?: (feature: Feature) => void
  onCancel?: (feature: Feature) => void
  onAfterDelete?: (feature: Feature) => void
  editAgain: (feature: Feature) => Feature
  saveControlsTop?: boolean
  hideCancel?: boolean
  hideDelete?: boolean
  hideSave?: boolean
  map?: JSX.Element
  user?: IAppUser
}

interface State {}

class EditFeatureDispatcher extends React.Component<Props, State> {
  render() {
    const parentKnowBetter = {
      //Parent know better:
      hideCancel: this.props.hideCancel,
      hideDelete: this.props.hideDelete,
      hideSave: this.props.hideSave,
      onAfterSave: this.props.onAfterSave,
      onCancel: this.props.onCancel,
      onAfterDelete: this.props.onAfterDelete,
      user: this.props.user,
      saveControlsTop: this.props.saveControlsTop,
      showTransformSelector: true,
      buttonsClassname: this.props.buttonsClassname,
      style: this.props.style,
      editAgain: this.props.editAgain,
      map: this.props.map,
      onBeforeDelete:
        appConfig.reg.regrelated.indexOf(this.props.layerInfo.url) != -1
          ? (feature: Feature, continieDelete: (f: Feature) => void) => {
              this.props.popupDispatcher.addPopups({
                deleteReason: {
                  width: '400px',
                  content: (
                    <OnBeforeDelete
                      continueDelete={feat => {
                        this.props.popupDispatcher.removePopups(['deleteReason'])
                        continieDelete(feat)
                      }}
                      feature={feature}
                      layerInfo={this.props.layerInfo}
                    />
                  ),
                  header: <div>Изберете причина за промяна</div>
                }
              })
            }
          : undefined
    }
    if (this.props.layerInfo.url == appConfig.streetreg.area.url) {
      return (
        <StreetAreaEditor
          layerInfo={this.props.layerInfo}
          feature={this.props.feature}
          editsDispatcher={this.props.editsDispatcher}
          geometryEditsDispatcher={this.props.geometryEditsDispatcher}
          //Parent know better:
          {...parentKnowBetter}
        />
      )
    }
    if (this.props.layerInfo.url == appConfig.archImport.planHistory.url) {
      return (
        <ArchPlanHistoryEditor
          layerInfo={this.props.layerInfo}
          feature={this.props.feature}
          editsDispatcher={this.props.editsDispatcher}
          geometryEditsDispatcher={this.props.geometryEditsDispatcher}
          //Parent know better:
          {...parentKnowBetter}
        />
      )
    }
    if (this.props.layerInfo.url == appConfig.reg.siteLine.id) {
      return (
        <SiteLineFeatureEditor
          {...parentKnowBetter}
          layerInfo={this.props.layerInfo}
          feature={this.props.feature}
          editsDispatcher={this.props.editsDispatcher}
          //Parent know better:
          hideGeometrySelector={true}
          hideSave={true}
          hideCancel={true}
          hideDelete={true}
        />
      )
    }
    if (this.props.layerInfo.url == appConfig.reg.plan.planUrl) {
      return (
        <RegPlanEditor
          {...parentKnowBetter}
          layerInfo={this.props.layerInfo}
          feature={this.props.feature}
          editsDispatcher={this.props.editsDispatcher}
          //Parent know better:
          hideGeometrySelector={true}
          hideSave={true}
          hideCancel={true}
          hideDelete={true}
        />
      )
    }
    if (this.props.layerInfo.url == appConfig.reg.parcels.parcelsUrl) {
      return (
        <ParcelFeatureEditor
          layerInfo={this.props.layerInfo}
          feature={this.props.feature}
          editsDispatcher={this.props.editsDispatcher}
          geometryEditsDispatcher={this.props.geometryEditsDispatcher}
          //Parent know better:
          {...parentKnowBetter}
        />
      )
    }
    if (this.props.layerInfo.url == appConfig.reg.quarters.quartersUrl) {
      return (
        <QuarterFeatureEditor
          layerInfo={this.props.layerInfo}
          feature={this.props.feature}
          editsDispatcher={this.props.editsDispatcher}
          geometryEditsDispatcher={this.props.geometryEditsDispatcher}
          //Parent know better:
          {...parentKnowBetter}
        />
      )
    }
    // choose editor by checking this.props.layerInfo.url == appConfig.clientsUrl() for example
    return (
      <AppFeatureEditor
        layerInfo={this.props.layerInfo}
        feature={this.props.feature}
        editsDispatcher={this.props.editsDispatcher}
        geometryEditsDispatcher={this.props.geometryEditsDispatcher}
        //Parent know better:
        {...parentKnowBetter}
      />
    )
  }
}

export default EditFeatureDispatcher
